module.exports = __webpack_public_path__ + "img/map-2.07df10f4.svg";